module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-early-treatment-block"
  }, [_c('div', {
    staticClass: "custom-early-treatment-block__container"
  }, [_c('div', {
    staticClass: "custom-early-treatment-block__title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.title)
    }
  }), _vm._l((_vm.props.row), function(row, i) {
    return _c('div', {
      key: i,
      staticClass: "custom-early-treatment-block__row"
    }, [_c('div', {
      staticClass: "custom-early-treatment-block__row-title",
      domProps: {
        "innerHTML": _vm._s(row.title)
      }
    }), _c('div', {
      staticClass: "custom-early-treatment-block__row-content",
      domProps: {
        "innerHTML": _vm._s(row.content)
      }
    })])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1918890a","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-early-treatment-block/custom-early-treatment-block.pug
// module id = 622
// module chunks = 1